import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import "./StrengthRatioCalculator.scss";

const belowRangeStyle={display:"block",marginBottom:"5px",backgroundColor:"#ff3131"}
const optimalRangeStyle={display:"block",marginBottom:"5px",backgroundColor:"#7ed957"}
const aboveRangeStyle={display:"block",marginBottom:"5px",backgroundColor:"#ff914d"}
function SquatInput({ exerciseName, style }) {
  return (
    <div className="c-exercise-load-wrapper">
      <label className="c-rep-input-label">{exerciseName}</label>

      <input style={style} className="strength-ratio-inputs input-val" type="text" value={"...%"}/>
      <input className="strength-ratio-inputs" type="text" />
    </div>
  );
}

export default function StrengthRatioCalculator() {
  const [isRatioCalcualted,setIsRatioCalculated]=useState(false)
  const [styling,setStyling]=useState({})
  const [backSquat,setBackSquat]=useState(false) //100
  const [frontSquat,setFrontSquat]=useState(false)
  const [deadlift,setDeadlift]=useState(false)
  const [splitSquat,setSplitSquat]=useState(false)
  const [benchPress,setBenchPress]=useState(false)//100
  const [overHeadPress,setOverHeadPress]=useState(false)
  const [inclinePress,setInclinePress]=useState(false)
  const [dip,setDip]=useState(false)
  const [chinup,setChinUp]=useState(false)
  const [validate,setValidate]=useState(false)

  const [calculatedFrontSquat,setCalculatedFrontSquat]=useState(false)
  const [calculatedDeadLift,setCalculatedDeadLift]=useState(false)
  const [calculatedSplitSquat,setCalculatedSplitSquat]=useState(false)
  const [calculatedOverHeadPress,setCalculatedOverHeadPress]=useState(false)
  const [calculatedInclinePress,setCalculatedInclinePress]=useState(false)
  const [calculatedDip,setCalculatedDip]=useState(false)
  const [calculatedChinUp,setCalculatedChinUp]=useState(false)
  const [frontSquatColor,setFrontSquatColor]=useState("")
  const [deadLiftColor,setDeadLiftColor]=useState("")
  const [splitSquatColor,setSplitSquatColor]=useState("")
  const [overHeadPressColor,setOverHeadPressColor]=useState("")
  const [inclinePressColor,setInclinePressColor]=useState("")
  const [dipColor,setDipColor]=useState("")
  const [chinUpColor,setChinUpColor]=useState("")

  const [backSquatRange,setBackSquatRange]=useState("100")
  const [benchPressRange,setBenchPressRange]=useState("100")
  const [forntSquatIdealLoadRange,setFrontSquatIdealLoadRange]=useState("60.00 - 70.00")
  const [DeadLiftRange,setDeadLiftRange]=useState("120.00 - 130.00")
  const [splitSquatRange,setSplitSquatRange]=useState("50.00 - 60.00")
  const [overheadPressRange,setOverheadPressRange]=useState("60.00 - 70.00")
  const [inclinePressRange,setInclinePressRange]=useState("75.00 - 85.00")
  const [dipRange,setDipRange]=useState("115.00 - 125.00")
  const [chinupRange,setChinupRange]=useState("115.00 - 125.00")

  useEffect(()=>{
    if(frontSquat&&deadlift&&splitSquat&&overHeadPress&&inclinePress&&dip&&chinup){
      setValidate(true)
    }else{
      setValidate(false)
      //
    }

  },[frontSquat,deadlift,splitSquat,overHeadPress,inclinePress,dip,chinup])
  let exercises=["Back Squat","Front Squat","Deadlift","Split Squat"]
  let exercisesTwo=["Bench Press","Overhead Press","Incline Press","Dip (Bodyweight + Added Weight)","Chin Up (Bodyweight + Added Weight)"]
  const calculateStrengthRatio=()=>{
    setBackSquatRange(((backSquat/100)*100))
    setBenchPressRange(((benchPress/100)*100))
    if(frontSquat){
      const idealLoadRangeFrontSquat=frontSquat>=60&&frontSquat<=70
      let parsedIntFrontSquat=parseInt(frontSquat)
      let calculatedFrontSquat=((parsedIntFrontSquat/backSquat)*100)
      calculatedFrontSquat=Math.round(calculatedFrontSquat)
      let frontSquatMinRange=((frontSquat/calculatedFrontSquat)*60)
      let frontSquatMaxRange=((frontSquat/calculatedFrontSquat)*70)
      setFrontSquatIdealLoadRange(`${parseInt(frontSquatMinRange)} - ${parseInt(frontSquatMaxRange)}`)
        // if(calculatedFrontSquat>=frontSquatMinRange&&calculatedFrontSquat<=frontSquatMaxRange){
        if(calculatedFrontSquat>=60&&calculatedFrontSquat<=70){
          // setStyling(optimalRangeStyle)
          setFrontSquatColor("optimal")
          setCalculatedFrontSquat(calculatedFrontSquat)
        }else if(calculatedFrontSquat<60){
          setCalculatedFrontSquat(calculatedFrontSquat)
          // setStyling(belowRangeStyle)
          setFrontSquatColor("below")
          
        }else{
          setCalculatedFrontSquat(calculatedFrontSquat)
          // setStyling(aboveRangeStyle)
          setFrontSquatColor("above")
        }
    }
     if(deadlift){
      let parsedIntDeadLift=parseInt(deadlift)
      let calculatedDeadLift=((parsedIntDeadLift/backSquat)*100)
      calculatedDeadLift=Math.round(calculatedDeadLift)
      let deadliftMinRange=((parsedIntDeadLift/calculatedDeadLift)*120)
      let deadliftMaxRange=((parsedIntDeadLift/calculatedDeadLift)*130)
      setDeadLiftRange(`${parseInt(deadliftMinRange)} - ${parseInt(deadliftMaxRange)}`)
      // if(calculatedDeadLift>=deadliftMinRange&&calculatedDeadLift<=deadliftMaxRange){
      if(calculatedDeadLift>=120&&calculatedDeadLift<=130){
        setCalculatedDeadLift(calculatedDeadLift)
        // setStyling(optimalRangeStyle)
        setDeadLiftColor("optimal")
      }else if(calculatedDeadLift<120){
        setDeadLiftColor("below")
        setCalculatedDeadLift(calculatedDeadLift)
        // setStyling(belowRangeStyle)
      }else{
        setDeadLiftColor("above")
        setCalculatedDeadLift(calculatedDeadLift)
        // setStyling(aboveRangeStyle)
      }
    }
    if(splitSquat){
      let parsedIntSplitSquat=parseInt(splitSquat)
      let calculatedSplitSquat=((parsedIntSplitSquat/backSquat)*100)
      calculatedSplitSquat=Math.round(calculatedSplitSquat)
      let splitSquatMinRange=((parsedIntSplitSquat/calculatedSplitSquat)*50)
      let splitSquatMaxRange=((parsedIntSplitSquat/calculatedSplitSquat)*60)
      setSplitSquatRange(`${parseInt(splitSquatMinRange)} - ${parseInt(splitSquatMaxRange)}`)
      if(calculatedSplitSquat>=50&&calculatedSplitSquat<=60){
        setCalculatedSplitSquat(calculatedSplitSquat)
        // setStyling(optimalRangeStyle)
        setSplitSquatColor("optimal")
      }else if(calculatedSplitSquat<50){
        setSplitSquatColor("below")
        setCalculatedSplitSquat(calculatedSplitSquat)
        // setStyling(belowRangeStyle)
      }else{
        setSplitSquatColor("above")
        setCalculatedSplitSquat(calculatedSplitSquat)
        // setStyling(aboveRangeStyle)
      }
    }

    if(inclinePress){
      let parsedIntInclinePress=parseInt(inclinePress)
      let calculatedInclinePress=((parsedIntInclinePress/benchPress)*100)
      calculatedInclinePress=Math.round(calculatedInclinePress)
      let minInclinePressRange=((parsedIntInclinePress/calculatedInclinePress)*75)
      let maxInclinePressRange=((parsedIntInclinePress/calculatedInclinePress)*85)
      setInclinePressRange(`${parseInt(minInclinePressRange)} - ${parseInt(maxInclinePressRange)}`)
      if(calculatedInclinePress>=75&&calculatedInclinePress<=85){
        setCalculatedInclinePress(calculatedInclinePress)
        // setStyling(optimalRangeStyle)
        setInclinePressColor("optimal")
      }else if(calculatedInclinePress<75){
        setInclinePressColor("below")
        setCalculatedInclinePress(calculatedInclinePress)
        // setStyling(belowRangeStyle)
      }else{
        setInclinePressColor("above")
        setCalculatedInclinePress(calculatedInclinePress)
        // setStyling(aboveRangeStyle)
      }
    }
    if(overHeadPress){
      let parsedIntOverheadPress=parseInt(overHeadPress)
      let calculatedOverHeadPress=((parsedIntOverheadPress/benchPress)*100)
      calculatedOverHeadPress=Math.round(calculatedOverHeadPress)
      let minOverheadpressRange=((parsedIntOverheadPress/calculatedOverHeadPress)*60)
      let maxOverheadpressRange=((parsedIntOverheadPress/calculatedOverHeadPress)*70)
      setOverheadPressRange(`${parseInt(minOverheadpressRange)} - ${parseInt(maxOverheadpressRange)}`)
      if(calculatedOverHeadPress>=60&&calculatedOverHeadPress<=70){
        setCalculatedOverHeadPress(calculatedOverHeadPress)
        // setStyling(optimalRangeStyle)
        setOverHeadPressColor("optimal")
      }else if(calculatedOverHeadPress<60){
        setOverHeadPressColor("below")
        setCalculatedOverHeadPress(calculatedOverHeadPress)
        // setStyling(belowRangeStyle)
      }else{
        setOverHeadPressColor("above")
        setCalculatedOverHeadPress(calculatedOverHeadPress)
        // setStyling(aboveRangeStyle)
      }
    }
    if(dip){
      let parsedIntDip=parseInt(dip)
      let calculatedDip=((parsedIntDip/benchPress)*100)
      // console.log("diiippp",calculatedDip)
      calculatedDip=Math.round(calculatedDip)
      let minDipRange=((parsedIntDip/calculatedDip)*115)
      let maxDipRange=((parsedIntDip/calculatedDip)*125)
      setDipRange(`${parseInt(minDipRange)} - ${parseInt(maxDipRange)}`)
      if(calculatedDip>=115&&calculatedDip<=125){
        setCalculatedDip(calculatedDip)
        // setStyling(optimalRangeStyle)
        setDipColor("optimal")
      }else if(calculatedDip<115){
        setDipColor("below")
        setCalculatedDip(calculatedDip)
        // setStyling(belowRangeStyle)
      }else{
        setDipColor("above")
        setCalculatedDip(calculatedDip)
        // setStyling(aboveRangeStyle)
      }
    }
    if(chinup){
      let parsedIntChinup=parseInt(chinup)
      let calculatedChinup=((parsedIntChinup/benchPress)*100)
      calculatedChinup=Math.round(calculatedChinup)
      // console.log("calacut chinup",calculatedChinUp,chinup)
      let minChinupRange=((parsedIntChinup/calculatedChinup)*115)
      let maxChinupRange=((parsedIntChinup/calculatedChinup)*125)
      setChinupRange(`${parseInt(minChinupRange)} - ${parseInt(maxChinupRange)}`)
      if(calculatedChinup>=115&&calculatedChinup<=125){
        setCalculatedChinUp(calculatedChinup)
        // setStyling(optimalRangeStyle)
        setChinUpColor("optimal")
      }else if(calculatedChinup<115){
        setChinUpColor("below")
        setCalculatedChinUp(calculatedChinup)
        // setCalculatedChinUp(parsedIntChinup)
        // setStyling(belowRangeStyle)
      }else{
        setCalculatedChinUp(calculatedChinup)
        setChinUpColor("above")
        // setCalculatedChinUp(parsedIntChinup)
        // setStyling(aboveRangeStyle)
      }
    }
  }
  return (
    <>
      <h2 className="repetition-Calc-heading">Strength Ratio Calculator</h2>
      <div
         className="strength-ratio-background"
        // style={{ background: "#eaedef", width: "99%", marginTop: "unset" }}
      >
        <div className="strength-ratio-calc-bolck-heading">
          <div className="exercise-column-header"><div style={{marginBottom:"18px",fontSize:"22px"}} >Exercise</div>
          {
          exercises.map((exercise)=>{
            return <p className="c-rep-input-label"  style={{marginBottom:"13px"}}>{exercise}</p>

          })
        }
          </div>
          <div className="exercise-column-header"><div style={{marginBottom:"18px",textAlign:"center",fontSize:"22px"}} >Projected 1 Rep Max</div>
          <input style={{display:"block",marginBottom:"5px",width:"168px"}} className="strength-ratio-inputs input-val" value={backSquat?backSquat:""} onChange={(e)=>{setBackSquat(e.target.value)}} type="text"/> 
          <input style={{display:"block",marginBottom:"5px",width:"168px"}} className="strength-ratio-inputs input-val" value={frontSquat?frontSquat:""} onChange={(e)=>setFrontSquat(e.target.value)} type="text"/> 
          <input style={{display:"block",marginBottom:"5px",width:"168px"}} className="strength-ratio-inputs input-val" value={deadlift?deadlift:""} onChange={(e)=>setDeadlift(e.target.value)}  type="text"/> 
          <input style={{display:"block",marginBottom:"5px",width:"168px"}} className="strength-ratio-inputs input-val" value={splitSquat?splitSquat:""} onChange={(e)=>setSplitSquat(e.target.value)} type="text"/> 
         
          </div>
          
          <div className="exercise-column-header"  ><div style={{marginBottom:"18px",fontSize:"22px"}} >Exercise</div>
          {
          exercisesTwo.map((exercise)=>{
            return <p className="c-rep-input-label" style={{marginBottom:"13px",width:"max-content"}}>{exercise}</p>
            // return exercise

          })
        }
          </div>
          <div className="exercise-column-header"><div style={{marginBottom:"18px",textAlign:"center",fontSize:"22px"}} >Projected 1 Rep Max</div>
          
          <input style={{display:"block",marginBottom:"5px",width:"168px"}} className="strength-ratio-inputs input-val" value={benchPress?benchPress:''} onChange={(e)=>{setBenchPress(e.target.value)}} type="text" />
          <input style={{display:"block",marginBottom:"5px",width:"168px"}} className="strength-ratio-inputs input-val"  value={overHeadPress?overHeadPress:""} onChange={(e)=>{setOverHeadPress(e.target.value)}}  type="text" />
          <input style={{display:"block",marginBottom:"5px",width:"168px"}} className="strength-ratio-inputs input-val"  value={inclinePress?inclinePress:""} onChange={(e)=>{setInclinePress(e.target.value)}} type="text" />
          <input style={{display:"block",marginBottom:"5px",width:"168px"}} className="strength-ratio-inputs input-val" value={dip?dip:""} onChange={(e)=>{setDip(e.target.value)}} type="text" />
          <input style={{display:"block",marginBottom:"5px",width:"168px"}} className="strength-ratio-inputs input-val" value={chinup?chinup:""} onChange={(e)=>{setChinUp(e.target.value)}} type="text" />
          {/* {
          exercisesTwo.map((input)=>{
            return <input style={{display:"block",marginBottom:"5px",width:"168px"}} className="strength-ratio-inputs input-val" type="text" />
          })
        } */}
          </div>
          
        </div>
       
          
        
        <div style={{display:"flex",justifyContent:"center"}}>
          {/* <button   disabled={validate?!validate:true} onClick={calculateStrengthRatio} className={!validate?"disable-btn":"calc-strength-ratio-btn"}>Calculate Strength Ratios</button> */}
          <button    onClick={calculateStrengthRatio} className={"calc-strength-ratio-btn"}>Calculate Strength Ratios</button>
        </div>

     
      </div>

     

      <div  style={{marginTop:"15px"}} className="strength-ratio-background">

        <div className="flex-wrapper">
          <div className="exercise-wrapper"><span>Exercise</span>
          {
          exercises.map((exercise)=>{
            return <p className="c-rep-input-label"  style={{marginBottom:"13px"}}>{exercise}</p>

          })
        }
          </div>
          <div className="strength-wrapper"><div className="str-heading">Strength Ratio</div>
          <input style={{display:"block",marginBottom:"5px"}} className="strength-ratio-inputs input-val-calc" type="text" value={"100%"}/>
          <input style={{display:"block",marginBottom:"5px"}} className={frontSquatColor?`${frontSquatColor} strength-ratio-inputs input-val-calc`:"strength-ratio-inputs input-val-calc"} type="text" value={calculatedFrontSquat?(parseInt(calculatedFrontSquat))+"%":"...%"}/>
          <input  style={{display:"block",marginBottom:"5px"}} className={deadLiftColor? `${deadLiftColor} strength-ratio-inputs input-val-calc`:"strength-ratio-inputs input-val-calc" } type="text" value={calculatedDeadLift?(parseInt(calculatedDeadLift))+"%":"...%"}/>
          <input  style={{display:"block",marginBottom:"5px"}} className={splitSquatColor?`${splitSquatColor} strength-ratio-inputs input-val-calc`:"strength-ratio-inputs input-val-calc"} type="text" value={calculatedSplitSquat?(parseInt(calculatedSplitSquat)+"%"):"...%"}/>
          </div>
          <div className="load-wrapper"><div className="load-heading">Ideal Load</div>
          <input style={{display:"block",marginBottom:"5px"}} className="strength-ratio-inputs input-val" value={parseInt(backSquatRange)} type="text" />
          <input style={{display:"block",marginBottom:"5px"}} className="strength-ratio-inputs input-val" value={forntSquatIdealLoadRange} type="text" />
          <input style={{display:"block",marginBottom:"5px"}} className="strength-ratio-inputs input-val" value={DeadLiftRange} type="text" />
          <input style={{display:"block",marginBottom:"5px"}} className="strength-ratio-inputs input-val" value={splitSquatRange} type="text" />
          </div>

        </div>
        <div  className="solid-line" />
        
        <div className="strength-ratio-indicator">
        <div>
          <div className="listintg-ratio-indicator">
            <div className="c-strength-ratio-optimal-range"></div>
            <span>Strength ratio within optimal range</span>
          </div>
          <div className="listintg-ratio-indicator">
            <div className="c-strength-ratio-below-range"></div>
            <span>Strength ratio  below optimal range</span>
          </div>
          <div className="listintg-ratio-indicator">
            <div className="c-strength-ratio-above-range"></div>
            <span>Strength ratio  above optimal range</span>
          </div>
        </div>
      </div>

      <div className="flex-wrapper" style={{marginTop:"39px"}}>
          <div className="exercise-wrapper">
          {
          exercisesTwo.map((exercise)=>{
            return <p className="c-rep-input-label"  style={{marginBottom:"13px"}}>{exercise}</p>

          })
        }
          </div>
          <div className="strength-wrapper">
          <input style={{display:"block",marginBottom:"5px"}} className="strength-ratio-inputs input-val-calc" type="text" value={"100%"}/>
          <input  style={{display:"block",marginBottom:"5px"}} className={overHeadPressColor?`${overHeadPressColor} strength-ratio-inputs input-val-calc`:"strength-ratio-inputs input-val-calc"} type="text" value={calculatedOverHeadPress?parseInt(calculatedOverHeadPress)+"%":"...%"}/>
          <input  style={{display:"block",marginBottom:"5px"}} className={inclinePressColor?`${inclinePressColor} strength-ratio-inputs input-val-calc`:"strength-ratio-inputs input-val-calc"} type="text" value={calculatedInclinePress?parseInt(calculatedInclinePress)+"%":"...%"}/>
          <input  style={{display:"block",marginBottom:"5px"}}className={dipColor?`${dipColor} strength-ratio-inputs input-val-calc`:"strength-ratio-inputs input-val-calc"} type="text" value={calculatedDip?parseInt(calculatedDip)+"%":"...%"}/>
          <input  style={{display:"block",marginBottom:"5px"}} className={chinUpColor?`${chinUpColor} strength-ratio-inputs input-val-calc`:"strength-ratio-inputs input-val-calc"} type="text" value={calculatedChinUp?parseInt(calculatedChinUp)+"%":"...%"}/>
          </div>
          <div className="load-wrapper">
          <input style={{display:"block",marginBottom:"5px"}} className="strength-ratio-inputs input-val" value={parseInt(benchPressRange)} type="text" />
          <input style={{display:"block",marginBottom:"5px"}} className="strength-ratio-inputs input-val" value={overheadPressRange} type="text" />
          <input style={{display:"block",marginBottom:"5px"}} className="strength-ratio-inputs input-val" value={inclinePressRange} type="text" />
          <input style={{display:"block",marginBottom:"5px"}} className="strength-ratio-inputs input-val" value={dipRange} type="text" />
          <input style={{display:"block",marginBottom:"5px"}} className="strength-ratio-inputs input-val" value={chinupRange} type="text" />
          </div>

        </div>
        </div>
    </>
  );
}
